import Config from '../../../common/js/utils/Config';
import Debug from '../../../common/js/utils/Debug';
import FT from '../../../common/js/utils/FeatureToggles';

export function navigate(history, path) {
  history.push(path);
}

export function getUrlParams() {
  var params = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    params[key] = value;
  });
  return params;
}

export const getHPIDSignInUrl = (lang = 'en') => {
  try {
    if (Config.get('environment') === 'stage') {
      return `/services/oauth_handler/hpbp/sign_in?locale=${Config.hpTechHpidLangMapping[lang]}&acr_values=urn:hpbp:hpid_stg`;
    } else {
      return `/services/oauth_handler/hpbp/sign_in?locale=${Config.hpTechHpidLangMapping[lang]}`;
    }
  } catch (e) {
    Debug.log('Exception: in getHPIDSignInUrl' + e);
    return '/services/oauth_handler/hpbp/sign_in?locale=en_US';
  }
};

export const getDomainSpecificUrl = (region = 'US') => {
  try {
    const regionURLMAPWex = {
      US: Config.get('wexGASiteUs'),
      EU: Config.get('wexGASiteEu'),
      AU: Config.get('wexGASiteAu'),
    };
    return regionURLMAPWex[region] ? regionURLMAPWex[region] : window.location.origin;
  } catch (err) {
    Debug.log('Exception in getDomainSpecificUrl' + err);
    return window.location.origin;
  }
};

export const getCookieDomain = () => {
  try {
    let host = window.location.host.split('.');
    let domain = host[host.length - 2] + '.' + host[host.length - 1];
    if (domain.includes('localhost')) {
      return 'localhost';
    }
    return domain;
  } catch (err) {
    Debug.log('Exception in getCookieDomain' + err);
    return '';
  }
};

export const ACCESS_REASON = {
  SERVICE: 'service',
  AWSMP: 'awsmp',
  DNTO: 'dnto',
  ONECLOUD: 'onecloud',
};

/* Checks if the user is allowed to self-signup.
 * Returns [allow, reason, value]
 * allow: boolean - true if user is allowed to self-signup
 * reason: string - an identifier for the source of permission into self-signup
 * value: any - value checked for permission
 *
 * For AdminX:
 * In case user lands on adminx /signup path, check if service name is present and it should be hp_protect_and_trace_always_on
 * In case not redirect user to 404 page, if service check is present, store the service in localstorage and process the company creation flow via onecloud
 *
 * For WFX:
 * Do not allow access to self-signup flow. Only exceptions is purchase through DNTO flow with localStorage check
 * or AWSMP with regToken in URL query string. Redirect to 404 otherwise. Also allow for specific service name
 */
export const getSelfSignupPermission = () => {
  if (Config.get('demo')) {
    return [true, 'demo', ''];
  }
  const param = getUrlParams();
  let dui_org_less_token = localStorage.getItem('dui_org_less_token');
  let dui_token_e = localStorage.getItem('dui_token_e');
  const selectedService = localStorage.getItem('selected_service');
  const service = param.service || selectedService;
  if (service === 'hp_protect_and_trace_always_on' || service === 'starter') {
    return [true, ACCESS_REASON.SERVICE, service];
  }

  if (localStorage.getItem('regToken') || param.regToken) {
    const regToken = param.regToken ? param.regToken : localStorage.getItem('regToken');
    return [true, ACCESS_REASON.AWSMP, regToken];
  }

  if (dui_org_less_token || dui_token_e) {
    return [true, ACCESS_REASON.ONECLOUD, dui_token_e || dui_org_less_token];
  }

  if (FT('wxp-self-signup')) {
    return [true, ACCESS_REASON.SERVICE, ''];
  } else {
    return [false, '', ''];
  }
};

export const allowSelfSignup = () => {
  return getSelfSignupPermission()[0];
};
